import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import FMPSelect from './FMPSelect';

export default class FMPBulkCustomerSelect extends PureComponent {
	render() {
		const {
			label,
			value,
			path,
			onChange,
			bulkCustomers,
			error,
			helpText,
			md,
			readOnly,
			multiple,
		} = this.props;

		const options = _.sortBy(bulkCustomers, 'name').map((bulkCustomer) => {
			const { bulkCustomerId, name } = bulkCustomer;
			return { value: bulkCustomerId, display: name };
		});

		return (
			<FMPSelect
				label={label}
				path={path}
				value={value}
				error={error}
				options={options}
				onChange={onChange}
				readOnly={readOnly}
				md={md}
				helpText={helpText}
				contained={false}
				multiple={multiple}
			/>
		);

		/*
		return (<Grid spacing={2} container>
			<Grid item xs={12} md={md}>
				<FormControl fullWidth={true} error={hasError}>
					<InputLabel htmlFor={path}>{label}</InputLabel>
					<Select
						value={value}
						onChange={_onChange}
						input={<Input id={path} readOnly={readOnly} />}
					>
						{_.sortBy(bulkCustomers, 'name').map((bulkCustomer, i) => {
							return (
								<MenuItem key={i} value={bulkCustomer.bulkCustomerId}>
									{bulkCustomer.name}
								</MenuItem>
							);
						})}
					</Select>
					{hasError && <FormHelperText>{error}</FormHelperText>}
					{(helpText && !hasError) && <FormHelperText>{helpText}</FormHelperText>}
				</FormControl>
			</Grid>
		</Grid>);
		 */
	}
}

FMPBulkCustomerSelect.propTypes = {
	label: PropTypes.string,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
	path: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	error: PropTypes.string,

	bulkCustomers: PropTypes.array.isRequired,
	md: PropTypes.number,
	helpText: PropTypes.string,
	readOnly: PropTypes.bool,
	multiple: PropTypes.bool,
};

FMPBulkCustomerSelect.defaultProps = {
	label: 'Bulk Customer',
	readOnly: false,
	md: 12,
};
